<template>
  <div class="form-check form-switch mb-0" :class="{ 'is-unavailable': isUnavailable }">
    <input
      class="form-check-input"
      type="checkbox"
      value="1"
      id="outfit"
      :disabled="isUnavailable"
      @change="outfitCheck($event)"
      :checked="$store.state.character.outfit"
    />
    <label
      class="form-check-label"
      for="outfit"
      :title="isUnavailable ? 'Classes de 4ª não possuem roupa alternativa' : ''"
    >Roupa Alternativa</label>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { NO_ALT_OUTFIT_JOB_IDS } from "@/config/jobs";

export default {
  name: "OutfitCheckbox",
  computed: {
    // 4th classes have no alternate outfit — the render backends ignore the
    // flag, so we disable the toggle to avoid a confusing no-op.
    isUnavailable() {
      const jobId = parseInt(this.$store.state.character.job?.[0], 10);
      return NO_ALT_OUTFIT_JOB_IDS.has(jobId);
    },
  },
  watch: {
    // If the user switches to a 4th class while the outfit is on, turn it off
    // so the stored state stays consistent with what's actually rendered.
    isUnavailable(unavailable) {
      if (unavailable && this.$store.state.character.outfit) {
        this.SAVE_OUTFIT(false);
      }
    },
  },
  methods: {
    ...mapMutations(["SAVE_OUTFIT"]),
    outfitCheck: function (event) {
      this.SAVE_OUTFIT(event.target.checked);
    },
  },
};
</script>

<style scoped>
.is-unavailable {
  opacity: 0.45;
}
.is-unavailable .form-check-label {
  cursor: not-allowed;
}
</style>
